import makeStyles from '@mui/styles/makeStyles'
import { MyAccountTheme, MaLoginContainerClasses } from '@dxp-module/themes'

const loginContainerStyles = makeStyles<
  MyAccountTheme,
  object,
  MaLoginContainerClasses
>(
  ({ palette, breakpoints }) => ({
    root: {
      padding: 60,
      margin: 16,
      [breakpoints.down(breakpoints.values.sm)]: {
        margin: 10,
      },
    },
    title: {},
    subTitle: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    subTitleContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    subTitleSecondary: {
      display: 'inline-block',
      marginLeft: 'auto',
      color: palette.error.main,
    },
    card: {},
    cardContent: {},
    text: {},
    link: {},
  }),
  { name: 'MyAccount_LoginContainer' }
)

export default loginContainerStyles
